import { clsx } from 'clsx'
import { Button } from 'component/Button'
import { Divider, Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { CombineSwitch } from 'page/catalog/combo/CombineSwitch'
import { Filter } from 'page/catalog/DemoCatalogFilters/Filter'
import { PriceFilter } from 'page/catalog/DemoCatalogFilters/PriceFilter'
import { SortButton } from 'page/catalog/SortButton/SortButton'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { ui } from 'store/home/ui/HomeUiStore'
import css from './FiltersPanel.module.scss'

export const FiltersPanel = observer(() => {
  const { small } = ui.window
  const demo = useDemo()
  const { basic, stand, options, form } = demo
  const { combineFilter, priceSorting } = demo.product
  const count = form.filtersCount

  const onReset = useLatestCallback(() => {
    form.clear()
  })

  const {
    brands,
    styles,
    categories,
    colors,
    tsum_categories,
    tsum_seasons,
    tsum_sizes,
    price_filter,
    filters,
  } = options

  if (!filters) return null

  const className = clsx(basic ? css.basic : css.full)
  const reset = !!count

  return (
    <Space className={className} gap={12} opposite wrap>
      <Space gap={8} wrap>
        {brands && <Filter filter={form.brands} options={brands} />}
        {styles && <Filter filter={form.styles} options={styles} />}
        {categories && <Filter filter={form.categories} options={categories} />}
        {tsum_categories && (
          <Filter filter={form.categories} options={tsum_categories} />
        )}
        {colors && <Filter filter={form.colors} options={colors} />}
        {tsum_seasons && (
          <Filter filter={form.seasons} options={tsum_seasons} />
        )}
        {tsum_sizes && <Filter filter={form.sizes} options={tsum_sizes} />}
        {price_filter && !stand && <PriceFilter />}
        {combineFilter && !basic && (
          <Space gap={4} height={32}>
            {!small && filters && <Divider height={16} tertiary />}
            <Space pad={[0, 8]}>
              <CombineSwitch />
            </Space>
          </Space>
        )}
        {reset && <Divider height={16} tertiary className={css.divider} />}
        {reset && (
          <Button compact text action={onReset} className={css.reset}>
            {i18n('ResetFilters')}
          </Button>
        )}
      </Space>
      {priceSorting && (
        <Space>
          <SortButton />
        </Space>
      )}
    </Space>
  )
})
